// apiConfig.js
import { baseApi } from "@/config";
export const API_CONFIG = {
  // baseUrl: "http://10.3.16.166:7003/api/pbl/localPost", // 基础 API URL
  baseUrl: `${baseApi}onlinePost`, // 基础 API URL
  baseUrl2: `${baseApi}`, // 基础 API URL
  weixinUrl: `https://pbl.cocorobo.cn/api/weixin/`, // 基础 API URL
  ////////////// 以下是账号列表的数据接口
  // 账户启用的接口
  ajaxstart: {
    functionName: "select_user_type1",
    r_type: null,
    page: null,
    num: null,
  },
  //停用或者启用的接口
  userstate: {
    functionName: "update_user_state",
  },
  //设置管理员
  ajax_admin: {
    functionName: "update_user_admin",
  },
  //学校查询
  ajax_school: {
    functionName: "select_school_name2", // 调用存储过程的名称
    u_name: "", // 用户输入的搜索关键词
    u_org: "", // 传入的组织 ID
    u_regC: "", // 传入的区域 
  },
  //组织查询
  ajax_org: {
    functionName: "select_organization",
  },
  //关键词查询
  ajax_school_name: {
    functionName: "select_school_name",
  },
  //新增学校
  ajax_add_school: {
    functionName: "insert_school2",
  },
  //新增组织
  ajax_add_org: {
    functionName: "insert_org2",
  },
  //确认移动
  ajax_confirm: {
    functionName: "updata_user_o_s",
  },
  //查询后缀
  ajax_Suffix: {
    functionName: "select_Suffix",
  },

  //查询随机码组织
  ajax_getliyuanCode: {
    functionName: "getliyuanCode",
  },
  //查询学校教研室
  ajax_selectPerInfoAllTea: {
    functionName: "selectPerInfoAllTea",
  },
  //查询个人信息
  ajax_selectliyuanUserInfo: {
    functionName: "selectliyuanUserInfo",
  },
 //查询班级名称
  ajax_selectliyuanCodename: {
    functionName: "selectliyuanCodename",
  },

  //查询个人信息
  ajax_selectliyuanOpenid: {
    functionName: "selectliyuanOpenid",
  },
  //查询通知信息
  ajax_selectnotNum: {
    functionName: "select_noticeCenter_statusNum",
  },
  //微信登录
  ajax_UpdateOpenId: {
    functionName: "UpdateOpenId",
  },
  //修改
  ajax_updateliyuanUserInfo: {
    functionName: "updateliyuanUserInfo",
  },
  // 查询权限
  ajax_schoolPermission: {
    functionName: "select_schoolPermissionNew",
  },

  // 查询首页应用
  ajax_allApp: {
    functionName: "select_liYuanAllApp",
  },

  // 查询更多热门应用
  ajax_morHotApp: {
    functionName: "select_morHotApp",
  },

    // 查询常用应用
    ajax_addedUsuallyApp: {
      functionName: "select_addedUsuallyApp",
    },
     // 查询后台预设常用ai工具
     ajax_AdminApp: {
      functionName: "select_AdminApp",
    },

    // 查询已添加常用应用
    ajax_usuallyApp: {
      functionName: "select_schUsuallyApp",
    },

    // 查询超级管理员信息
    ajax_roleUser: {
      functionName: "select_roleUser",
    },
    
    // 查询coconote登录学生列表
    selectSCourseStudents: {
      functionName: "selectSCourseStudents",
    },

  //新增学校应用
  ajax_add_usuallyApp: {
    functionName: "insert_usuallyApp",
  },

  //删除学校应用
  ajax_del_usuallyApp: {
    functionName: "del_usuallyApp",
  },
  //查询组织
  ajax_liYuanOrg: {
    functionName: "select_liYuanOrgnew",
  },
  //查询单独荔园组织
  select_liYuanOrgTwo: {
    functionName: "select_liYuanOrgTwo",
  },
  //查询单独荔园组织
  select_liYuanOrgssy: {
    functionName: "select_liYuanOrgssy",
  },
  //无后缀登录时查询是否是账户
  ajax_liYuanAcc: {
    functionName: "select_liYuanAcc",
  },
  //随机码登录查询课程学生账户
  ajax_selectCourseByIc2: {
    functionName: "selectCourseByIc2",
  },

  //新随机码登录查询课程学生账户
  ajax_selectCourseByIc2N: {
    functionName: "selectCourseByIc2N",
  },
  //根据随机码获取学生
  ajax_selectSnameByCid: {
    functionName: "selectSnameByCid",
  },


	//根据随机码获取学生
	ajax_selectSnameByCidAndOid: {
		functionName: "selectSnameByCidAndOid",
	},

  //查询组织
  select_liYuanCampus: {
    functionName: "select_liYuanCampus",
  },
  
  //查询组织
  teacherRegistration: {
    functionName: "teacherRegistration",
  },

  //查询cocofrow最近使用与收藏
  ajax_appStoreSave: {
    functionName: "select_lyAppStoreSave",
  },
  ////////////// 以下是账号审核的数据接口

  moveUser: {
    functionName: "account_update_user2", // 存储过程名称
  },

  getKanbanBasedata: {
    functionName: "getKanbanBasedata", // 存储过程名称
  },
  getKanbanAIdata: {
    functionName: "getKanbanAIdata", // 存储过程名称
  },
  getKanbanTeadata: {
    functionName: "getKanbanTeadata", // 存储过程名称
  },
  getKanbanTeaManagedata: {
    functionName: "getKanbanTeaManagedata", // 存储过程名称
  },
  getliyuanorgPid: {
    functionName: "getliyuanorgPid", // 存储过程名称
  },

  // 获取所有记录接口（综合了待审核、已通过、已拒绝的数据）
  allRecords: {
    functionName: "select_requestuser2", // 基本功能名
    page: 1,
    num: 10,
  },
};
